import "./file.js";
export { WebPartsPersonalizationScope, WebPartDefinitions, WebPartDefinition, LimitedWebPartManager, } from "./types.js";
//# sourceMappingURL=index.js.map